import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';

import * as styles from './TestingHeader.module.scss';

export const TestingHeader: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames(styles.paddingContainerTesting, 'white-bg')}
		>
			<WidthContainer>
				<UnderlinedHeader
					subtitleClassName="font-400"
					subtitle="QA and functional testing. Nothing surprises you."
				>
					Testing and Quality Assurance
					<p className="pb-3">Engineering Services</p>
				</UnderlinedHeader>
			</WidthContainer>
		</PaddingContainer>
	);
};
